import { configureRequestParams, getErrorMessage } from '@/utils/helpers'

import axios from './instance'

/**
 * Gets the list of events.
 */
export const getEvents = async (filters) => {
  const params = configureRequestParams(
    [{ id: 'date' }, { id: 'start_time' }],
    { pageIndex: 0, pageSize: 1000 },
    null,
    filters,
  )
  try {
    return await axios.get(
      `/events/${params}&expand=student_certificates,registrations,certificates&order_by=date,start_time`,
    )
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Add a new event.
 * @param {object} payload - The event data to be added.
 */
export const addEvent = async (payload) => {
  try {
    return await axios.post('/events/', payload)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Get a event.
 * @param {string} id - The event to get.
 */
export const getEvent = async (id) => {
  try {
    return await axios.get(
      `/events/${id}/?expand=student_certificates,student_certificates.certificate,student_certificates.certificate.proficiency_questions,student_certificates.course_records,student_certificates.course_records.course,certificates,additional_trainings,registrations,roster`,
    )
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Update an event.
 * @param {object} payload - The event data to be updated.
 */
export const updateEvent = async (payload) => {
  try {
    return await axios.patch(`/events/${payload.id}/`, payload)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Deletes an event.
 * @param {string} id - The event id to be deleted.
 */
export const deleteEvent = async (id) => {
  try {
    return await axios.delete(`/events/${id}/`)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Registers a student certificate for an event.
 * @param {string} eventId
 * @param {string} studentCertificates
 * @returns
 */
export const registerForEvent = async (eventId, studentCertificates) => {
  try {
    return await axios.post(`/events/${eventId}/register/`, { studentCertificates })
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Cancels registrations for a student for an event.
 * @param {string} eventId
 * @param {string} studentCertificates
 */
export const unregisterForEvent = async (eventId, studentCertificates) => {
  try {
    return await axios.post(`/events/${eventId}/unregister/`, { studentCertificates })
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}
